import { API_ENDPOINT } from 'utils/constants';
import { submit } from 'utils/proxy';

const url = `${API_ENDPOINT}/api/v1/role`;

const roleService = {
  list,
  create,
  show,
  update,
  remove,
  droplist,
  menuList,
};

function list(option = {}) {
  const { size, page, sort, name, code } = option;
  const params = {
    size: size ? size : 10,
    page: page ? page : 1,
    sort: sort ? sort : '+name',
  };

  if(name) params.name = name;
  if(code) params.code = code;

  return submit('GET', url, params, {});
}

function create(data) {
  return submit('POST', `${url}/`, data, {});
}

function show(id) {
  return submit('GET', `${url}/${id}`, {}, {});
}

function remove(id) {
  return submit('DELETE', `${url}/${id}`, {}, {});
}

function update(data) {
  return submit('PUT', `${url}/`, data, {});
}

function droplist(name) {
  const params = {
    name: name ? name : '',
  };

  return submit('GET', `${url}/droplist`, params, {});
}

function menuList(id) {
  return submit('GET', `${url}/${id}/menu/`, {}, {});
}

export default roleService;
